export default {
	/**
	 * Set all subscriber fields
	 * @param {Array} answers 
	 */
	setAnswers(state, answers) {
		state.all = answers
	},
}
